import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5611dea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contactSection",
  id: "contactSection"
}, null, -1))
const _hoisted_3 = { class: "main container" }
const _hoisted_4 = {
  class: "box",
  "data-scroll": "",
  "data-scroll-sticky": "",
  "data-scroll-target": "#contactSection"
}
const _hoisted_5 = { class: "top-cont" }
const _hoisted_6 = { class: "ttl fira bold uppercase wc-lg" }
const _hoisted_7 = { class: "desc fira wc-lg" }
const _hoisted_8 = {
  key: 0,
  class: "fira wc-lg"
}
const _hoisted_9 = {
  key: 1,
  class: "fira wc-lg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "11",
  height: "8",
  viewBox: "0 0 11 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.769531 1.12939L5.26953 6.12939L9.76953 1.12939",
    stroke: "#182236",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "check-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_19 = {
  for: "check2",
  class: "fira wc-lg"
}
const _hoisted_20 = { class: "check-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_22 = {
  for: "checkInfo2",
  class: "fira wc-lg"
}
const _hoisted_23 = { class: "fira bold uppercase wc-lg" }
const _hoisted_24 = {
  key: 0,
  class: "done"
}
const _hoisted_25 = { class: "box" }
const _hoisted_26 = { class: "top-cont" }
const _hoisted_27 = { class: "title luxury uppercase wc-lg" }
const _hoisted_28 = { class: "content" }
const _hoisted_29 = { class: "switcher" }
const _hoisted_30 = { class: "fira bold uppercase wc-lg" }
const _hoisted_31 = { class: "fira bold uppercase wc-lg" }
const _hoisted_32 = { class: "bottom-cont" }
const _hoisted_33 = { class: "item" }
const _hoisted_34 = { class: "data-cont wc-lg" }
const _hoisted_35 = { class: "ttl fira wc-lg medium" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "call fira wc-lg" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "socialCall fira wc-lg" }
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "email fira wc-lg" }
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "item" }
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.2391 16.258H10.1668C9.96727 16.2428 9.77799 16.1639 9.62678 16.0329C9.47558 15.9019 9.37055 15.7257 9.32708 15.5305L7.89765 9.201L1.56818 7.77137C1.30715 7.7127 1.08382 7.54496 0.955134 7.31047C0.826249 7.07598 0.804321 6.79743 0.894922 6.54564C0.985331 6.29384 1.17962 6.0932 1.42834 5.99435L15.4775 0.410947C15.7043 0.321306 15.957 0.324192 16.1819 0.418641C16.4066 0.513285 16.5855 0.691991 16.6801 0.916853C16.7746 1.14153 16.7775 1.39449 16.6878 1.6213L11.1044 15.6679C11.0357 15.8416 10.9167 15.9907 10.7624 16.0958C10.6081 16.201 10.4258 16.2575 10.2392 16.2579L10.2391 16.258ZM4.91718 6.61482L8.88179 7.51029C9.05223 7.54972 9.20823 7.63609 9.33192 7.75978C9.45561 7.88347 9.54217 8.03948 9.58142 8.2101L10.4769 12.1747L14.1618 2.93685L4.91718 6.61482Z",
      fill: "#940128"
    })
  ])
], -1))
const _hoisted_46 = { class: "fira bold uppercase wc-lg" }
const _hoisted_47 = { class: "map" }

import { ref, computed, onMounted, watch } from "vue";
import { get, forOwn } from "lodash";
import { useMenuStore } from "@/store/pinia/menu";
import fn from "@/helpers/func";
import { MenuItem } from "@/store/ts/interfaces/state.interface";

// Define store

export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */

const store = useMenuStore();

// Define props


// Reactive data
const getSubject = computed(() => {
    return get(store, "indx.widgets.subjects");
});
const getSubjectMenu = computed(() => {
    const arr: MenuItem[] = [];
    forOwn(getSubject.value, function (value: MenuItem, key: string): void {
        if (key.includes("item")) {
            arr.push(value);
        }
    });
    return arr;
});
const getConfData = computed(() => {
    return get(props.contentData, "conf");
});
const getTaxonomies = computed(() => {
    return get(store, "indx.terms.map_city_centers");
});
const getData = computed(() => {
    let arr = get(props.contentData, "data.list");
    arr.forEach((item: any) => {
        item.currentLocation = getTaxonomies.value.find(
            (el: any) => parseFloat(el.id) === parseFloat(item.map_city_centers)
        );
    });
    return arr;
});

// Define global variables
const currentCity = ref("batumi");
const Name = ref("");
const Email = ref("");
const Phone = ref("");
const Comment = ref("");
const Agree = ref(false);
const Information = ref(false);
const openSelect = ref(false);
const activeBatumi = ref(true);
const activeTbilisi = ref(false);
const activeSelect = ref(null);
const doneMSG = ref(false);
const Errors = ref({
    activeSelect: false,
    Name: false,
    Email: false,
    Phone: false,
    Comment: false,
    Agree: false,
    InfoErr: false,
});
const mapOptions = ref({
    zoom: 15,
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#1d2c4d",
                },
            ],
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1a3646",
                },
            ],
        },
        {
            featureType: "landscape",
            stylers: [
                {
                    color: "#ffffff",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#283d6a",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#6f9ba5",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1d2c4d",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#7fb86c",
                },
            ],
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#3C7680",
                },
            ],
        },
        {
            featureType: "road",
            stylers: [
                {
                    color: "#d1d1d1",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#304a7d",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#d1d1d1",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#595f6e",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#2c6675",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#d1d1d1",
                },
            ],
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#d1d1d1",
                },
            ],
        },
        {
            featureType: "road.local",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#d1d1d1",
                },
            ],
        },
        {
            featureType: "road.local",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#98a5be",
                },
            ],
        },
        {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#ffffff",
                },
            ],
        },
        {
            featureType: "transit.line",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#ffffff",
                },
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
                {
                    color: "#3a4762",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#0e1626",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#4d8ec9",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#4e6d70",
                },
            ],
        },
    ],
});

const getDarkEvent = computed(() => store.isDark);

// WATCHER
watch(getDarkEvent, () => {
    if (getDarkEvent.value) {
        mapOptions.value.styles = [
            {
                elementType: "geometry",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#8ec3b9",
                    },
                ],
            },
            {
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1a3646",
                    },
                ],
            },
            {
                featureType: "administrative.country",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#4b6878",
                    },
                ],
            },
            {
                featureType: "administrative.land_parcel",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "administrative.land_parcel",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#64779e",
                    },
                ],
            },
            {
                featureType: "administrative.province",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#4b6878",
                    },
                ],
            },
            {
                featureType: "landscape",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "landscape.man_made",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#334e87",
                    },
                ],
            },
            {
                featureType: "landscape.natural",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#023e58",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#283d6a",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#6f9ba5",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#023e58",
                    },
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#3C7680",
                    },
                ],
            },
            {
                featureType: "poi.place_of_worship",
                elementType: "geometry.fill",
                stylers: [
                    {
                        visibility: "on",
                    },
                ],
            },
            {
                featureType: "poi.place_of_worship",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#98a5be",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#2c6675",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#023e58",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#255763",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#b0d5ce",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#023e58",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#98a5be",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                featureType: "transit.line",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#283d6a",
                    },
                ],
            },
            {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#3a4762",
                    },
                ],
            },
            {
                featureType: "water",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#0e1626",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#4e6d70",
                    },
                ],
            },
        ];
    } else {
        mapOptions.value.styles = [
            {
                elementType: "geometry",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                elementType: "labels.text.fill",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1a3646",
                    },
                ],
            },
            {
                featureType: "landscape",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#283d6a",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#6f9ba5",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#7fb86c",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#3C7680",
                    },
                ],
            },
            {
                featureType: "road",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#304a7d",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#595f6e",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#2c6675",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#98a5be",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                ],
            },
            {
                featureType: "transit.line",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit.line",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#3a4762",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#0e1626",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#4d8ec9",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#4e6d70",
                    },
                ],
            },
        ];
    }
});

// Custom Functions
async function sendReq() {
    const formData = {
        subject: activeSelect.value,
        name: Name.value,
        email: Email.value,
        phone: Phone.value,
        comment: Comment.value,
        formType: "contactForm",
    };
    let tmp = await fn.postData("main/saveSubmitedForm", formData);

    return true;
}
function NumbersOnly(evt: any) {
    if (Phone.value) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46
        ) {
            evt.preventDefault();
        } else {
            return true;
        }
    }
}
function validateEmail(email: string) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}
const selectMenu = (item: any): void => {
    activeSelect.value = item;
};
const cleatInputs = (): void => {
    activeSelect.value = null;
    Name.value = "";
    Email.value = "";
    Phone.value = "";
    Comment.value = "";
    Agree.value = false;
    Information.value = false;
};
const sendData = (): void => {
    if (activeSelect.value === null) {
        Errors.value.activeSelect = true;
    } else if (Name.value.length <= 3 || Name.value === "") {
        Errors.value.Name = true;
    } else if (!validateEmail(Email.value)) {
        Errors.value.Email = true;
    } else if (Phone.value === "") {
        Errors.value.Phone = true;
    } else if (Comment.value.length <= 3 || Comment.value === "") {
        Errors.value.Comment = true;
    } else if (!Agree.value) {
        Errors.value.Agree = true;
    } else if (!Information.value) {
        Errors.value.InfoErr = true;
    } else {
        Errors.value.Agree = false;
        Errors.value.activeSelect = false;
        Errors.value.Name = false;
        Errors.value.Email = false;
        Errors.value.Phone = false;
        Errors.value.Comment = false;
        Errors.value.InfoErr = false;
        sendReq();
        cleatInputs();
        doneMSG.value = true;
        window.setTimeout(() => {
            doneMSG.value = false;
        }, 2000);
    }
};
// Custom functions
const openDropDown = (e: any): void => {
    e.stopPropagation();
    openSelect.value = !openSelect.value;
};
const switchBatumi = (): void => {
    currentCity.value = "batumi";
    activeBatumi.value = true;
    activeTbilisi.value = false;
    store.triggerUpdate = !store.triggerUpdate;
    window.setTimeout(() => {
        store.triggerUpdate = !store.triggerUpdate;
    }, 500);
};
const switchTbilisi = (): void => {
    currentCity.value = "tbilisi";
    activeTbilisi.value = true;
    activeBatumi.value = false;
    store.triggerUpdate = !store.triggerUpdate;
    window.setTimeout(() => {
        store.triggerUpdate = !store.triggerUpdate;
    }, 500);
};
onMounted(() => {
    document.addEventListener("click", () => {
        openSelect.value = false;
    });
    if (getDarkEvent.value) {
        mapOptions.value.styles = [
            {
                elementType: "geometry",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#8ec3b9",
                    },
                ],
            },
            {
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1a3646",
                    },
                ],
            },
            {
                featureType: "administrative.country",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#4b6878",
                    },
                ],
            },
            {
                featureType: "administrative.land_parcel",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "administrative.land_parcel",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#64779e",
                    },
                ],
            },
            {
                featureType: "administrative.province",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#4b6878",
                    },
                ],
            },
            {
                featureType: "landscape",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "landscape.man_made",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#334e87",
                    },
                ],
            },
            {
                featureType: "landscape.natural",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#023e58",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#283d6a",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#6f9ba5",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#023e58",
                    },
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#3C7680",
                    },
                ],
            },
            {
                featureType: "poi.place_of_worship",
                elementType: "geometry.fill",
                stylers: [
                    {
                        visibility: "on",
                    },
                ],
            },
            {
                featureType: "poi.place_of_worship",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#98a5be",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#2c6675",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#023e58",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#255763",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#b0d5ce",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#023e58",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#98a5be",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                featureType: "transit.line",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#283d6a",
                    },
                ],
            },
            {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#3a4762",
                    },
                ],
            },
            {
                featureType: "water",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#0e1626",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#111929",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#4e6d70",
                    },
                ],
            },
        ];
    } else {
        mapOptions.value.styles = [
            {
                elementType: "geometry",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                elementType: "labels.text.fill",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1a3646",
                    },
                ],
            },
            {
                featureType: "landscape",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#283d6a",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#6f9ba5",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#1d2c4d",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#7fb86c",
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#3C7680",
                    },
                ],
            },
            {
                featureType: "road",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#304a7d",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "road",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#595f6e",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#2c6675",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#d1d1d1",
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#98a5be",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                ],
            },
            {
                featureType: "transit.line",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit.line",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit.station",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#3a4762",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#0e1626",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#4d8ec9",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#4e6d70",
                    },
                ],
            },
        ];
    }
});

return (_ctx: any,_cache: any) => {
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$fn.tr("Contact us")), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$fn.tr(
                                "White a comment Fusce mollis neque id elementum finibus. Cras eu malesuada urna."
                            )), 1)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (sendData()), ["prevent"]))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["inp select", { err: Errors.value.activeSelect }]),
            onClick: openDropDown
          }, [
            (activeSelect.value !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(activeSelect.value), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$fn.tr("Choose subject")), 1)),
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { active: openSelect.value }])
            }, _hoisted_11, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["content", { active: openSelect.value }]),
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).disableScrollStatus = true)),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).disableScrollStatus = false))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSubjectMenu), (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "fira wc-lg",
                  key: index,
                  onClick: ($event: any) => (selectMenu(item))
                }, _toDisplayString(item), 9, _hoisted_12))
              }), 128))
            ], 34)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["inp", { err: Errors.value.Name }])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "fira wc-lg",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((Name).value = $event)),
              placeholder: _ctx.$fn.tr('Your Name')
            }, null, 8, _hoisted_13), [
              [_vModelText, Name.value]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["inp", { err: Errors.value.Email }])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "fira wc-lg",
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((Email).value = $event)),
              placeholder: _ctx.$fn.tr('Your Email')
            }, null, 8, _hoisted_14), [
              [_vModelText, Email.value]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["inp", { err: Errors.value.Phone }])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: "fira wc-lg",
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((Phone).value = $event)),
              placeholder: _ctx.$fn.tr('Your Phone'),
              onKeypress: _cache[5] || (_cache[5] = ($event: any) => (NumbersOnly($event)))
            }, null, 40, _hoisted_15), [
              [_vModelText, Phone.value]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["inp text", { err: Errors.value.Phone }])
          }, [
            _withDirectives(_createElementVNode("textarea", {
              class: "fira wc-lg",
              placeholder: _ctx.$fn.tr('Please Comment'),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((Comment).value = $event))
            }, "\n                        ", 8, _hoisted_16), [
              [_vModelText, Comment.value]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["check-box-cont2", { err: Errors.value.Agree }])
          }, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "check2",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((Agree).value = $event))
              }, null, 512), [
                [_vModelCheckbox, Agree.value]
              ]),
              _hoisted_18
            ]),
            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$fn.tr(
                                "I agree to my personal data being managed for the purpose of responding to my request *"
                            )), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["check-box-cont2", { err: Errors.value.InfoErr }])
          }, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "checkInfo2",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((Information).value = $event))
              }, null, 512), [
                [_vModelCheckbox, Information.value]
              ]),
              _hoisted_21
            ]),
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$fn.tr(
                                "I would like to receive information and updates from Alliance group that may be of interest to me."
                            )), 1)
          ], 2),
          _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.$fn.tr("Submit")), 1),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (doneMSG.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$fn.tr("Send!")), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$get(_unref(getConfData), "header.title")), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              onClick: switchBatumi,
              class: _normalizeClass({ active: activeBatumi.value })
            }, [
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$get(_unref(getData), "1.currentLocation.title")), 1)
            ], 2),
            _createElementVNode("button", {
              onClick: switchTbilisi,
              class: _normalizeClass({ active: activeTbilisi.value })
            }, [
              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$get(_unref(getData), "0.currentLocation.title")), 1)
            ], 2)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "step",
              key: index
            }, [
              (item?.currentLocation?.slug == currentCity.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$get(
                                                    item,
                                                    "currentLocation.name"
                                                )), 1),
                          _createElementVNode("a", {
                            href: `https://www.google.com/maps?q=loc:${_ctx.$get(
                                                item,
                                                'currentLocation.lat'
                                            )},${_ctx.$get(
                                                item,
                                                'currentLocation.long'
                                            )}`,
                            class: "adress fira wc-lg",
                            target: "_blank"
                          }, _toDisplayString(_ctx.$get(
                                                    item,
                                                    "currentLocation.adress"
                                                )), 9, _hoisted_36),
                          _createElementVNode("p", _hoisted_37, [
                            _createTextVNode(_toDisplayString(_ctx.$fn.tr("Direct Call:")) + " ", 1),
                            _createElementVNode("a", {
                              href: `tel: ${_ctx.$get(
                                                    item,
                                                    'currentLocation.phone'
                                                )}`,
                              class: "fira bold wc-lg"
                            }, _toDisplayString(_ctx.$get(
                                                        item,
                                                        "currentLocation.phone"
                                                    )), 9, _hoisted_38)
                          ]),
                          _createElementVNode("p", _hoisted_39, [
                            _createTextVNode(_toDisplayString(_ctx.$fn.tr("Telegram, Facebook: ")) + " ", 1),
                            _createElementVNode("a", {
                              href: `tel: ${_ctx.$get(
                                                    item,
                                                    'currentLocation.socials'
                                                )}`,
                              class: "fira bold wc-lg"
                            }, _toDisplayString(_ctx.$get(
                                                        item,
                                                        "currentLocation.socials"
                                                    )), 9, _hoisted_40)
                          ]),
                          _createElementVNode("p", _hoisted_41, [
                            _createTextVNode(_toDisplayString(_ctx.$fn.tr("Email: ")) + " ", 1),
                            _createElementVNode("a", {
                              href: `mailto: ${_ctx.$get(
                                                    item,
                                                    'currentLocation.email'
                                                )}`,
                              class: "fira bold wc-lg"
                            }, _toDisplayString(_ctx.$get(
                                                        item,
                                                        "currentLocation.email"
                                                    )), 9, _hoisted_42)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("a", {
                          href: `https://www.google.com/maps?q=loc:${_ctx.$get(
                                            item,
                                            'currentLocation.lat'
                                        )},${_ctx.$get(
                                            item,
                                            'currentLocation.long'
                                        )}`,
                          target: "_blank"
                        }, [
                          _createElementVNode("button", null, [
                            _hoisted_45,
                            _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$fn.tr("Build the route")), 1)
                          ])
                        ], 8, _hoisted_44)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_GMapMap, {
                        center: {
                                        lat: parseFloat(
                                            _ctx.$get(item, 'currentLocation.lat')
                                        ),
                                        lng: parseFloat(
                                            _ctx.$get(item, 'currentLocation.long')
                                        ),
                                    },
                        options: mapOptions.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_GMapMarker, {
                            position: {
                                            lat: parseFloat(
                                                _ctx.$get(
                                                    item,
                                                    'currentLocation.lat'
                                                )
                                            ),
                                            lng: parseFloat(
                                                _ctx.$get(
                                                    item,
                                                    'currentLocation.long'
                                                )
                                            ),
                                        },
                            icon: _ctx.$get(item, 'Icon.0.url'),
                            draggable: false
                          }, null, 8, ["position", "icon"])
                        ]),
                        _: 2
                      }, 1032, ["center", "options"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})